const React = require('react');
const PropTypes = require('prop-types');
const RiskDot = require('./RiskDot');
require('./RiskDotList.scss');

const ALL_RISK_VALUES = [1, 2, 3, 4, 5, 6, 7];

const RiskDotList = ({ index }) => (
    <div className="risk-indicator__risk-dot-list">
        {ALL_RISK_VALUES.map(i => (
            <RiskDot
                active={i === index}
                key={i}
                style={{ left: (i - 1) * 42 - 0 }}
                value={i}
            />
        ))}
    </div>
);

RiskDotList.propTypes = {
    index: PropTypes.number.isRequired,
};

module.exports = RiskDotList;
